export default "__VITE_ASSET__BbHE5EcB__"